<web-header></web-header>
<div class="content-wrapper">
  <router-outlet></router-outlet>
</div>
<web-footer></web-footer>
